import { http } from '../../config/axios'

export interface FaturaFaturamentoResponse {
  assuntoEmail: string
  textoEmail: string
}

const getFaturaFaturamentoService = (id: string): Promise<FaturaFaturamentoResponse> => {
  return http
    .get(`api/fatura/faturamento/${id}`)
    .then((res) => {
      return res.data as FaturaFaturamentoResponse
    })
    .catch((error) => {
      console.error('Erro getFaturaFaturamento', error)
      throw Error(error.response?.data)
    })
}

export default getFaturaFaturamentoService;
